import { useEffect, useRef, useState } from "react"
import { QuestionList } from "../item/QuestionList"
import { TopBar } from "../bar/topbar"
import { FavouritesContext, IFavouritesFolder } from "./favouritesProvider"
import { FavouritesMenu } from "./favouritesMenu"
import { Box } from "@mui/system"
import { useIsMobile } from "../device/useIsMobile"
import { useContextWithGuard } from "../helpers/useContextWithGuard"
import { ToggleSearchAlbumButton } from "../nav/toggleSearchAlbumButton"
import { Logo } from "../theme/logo"
import { TiledBackground } from "../theme/background"
import { Theme, useTheme } from "@mui/material"
import { FolderSelect } from "./folderSelect"
import { DeleteFolderButton } from "./deleteFolderButton"
import { EditFolderButton } from "./editFolderButton"
import { BelowBar } from "../bar/belowBar"
import { NavMenu } from "../nav/navMenu"


export const FavouritesPage = () => {
    const theme = useTheme<Theme>();
    const { folders } = useContextWithGuard(FavouritesContext, "AlbumContext");
    const [selectedFolder, setSelectedFolder] = useState<IFavouritesFolder | undefined>(folders[0]);

    const topbarRef = useRef<HTMLDivElement>(null);
    const [topbarHeight, setTopbarHeight] = useState(0);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (topbarRef.current) {
            const measuredHeight = topbarRef.current.offsetHeight;
            setTopbarHeight(measuredHeight);
        }
    }, []);

    useEffect(() => {
        if (selectedFolder && folders.indexOf(selectedFolder) == -1) {
            setSelectedFolder(folders[0]);
        }
    }, [folders])

    return (
        isMobile
            ?
            <>
                <TopBar ref={topbarRef} >
                    <FavouritesMenu items={selectedFolder?.items ?? []} />
                    <ToggleSearchAlbumButton />
                    <Box flexGrow={1} />
                    <Logo />
                </TopBar>
                <div style={{
                    marginTop: topbarHeight,
                    position: "relative",
                    minHeight: "100vh",
                    background: theme.bee.contentBackground,
                }}>
                    <BelowBar topbarHeight={topbarHeight} >
                        <FolderSelect
                            selectedValue={selectedFolder?.id ?? 0}
                            setSelectedValue={(id: number) => {
                                setSelectedFolder(folders.find(f => f.id == id));
                            }} folders={folders} />
                        {
                            selectedFolder &&
                            <DeleteFolderButton folderId={selectedFolder?.id} />
                        }
                        {
                            selectedFolder &&
                            <EditFolderButton folder={selectedFolder} />
                        }
                    </BelowBar>
                    <QuestionList data={selectedFolder?.items ?? []} />
                </div>
            </>
            :

            <>
                <TopBar ref={topbarRef} >
                    <FavouritesMenu items={selectedFolder?.items ?? []} />
                    <FolderSelect
                        selectedValue={selectedFolder?.id ?? 0}
                        setSelectedValue={(id: number) => {
                            setSelectedFolder(folders.find(f => f.id == id));
                        }} folders={folders} />
                    {
                        selectedFolder &&
                        <DeleteFolderButton folderId={selectedFolder?.id} />
                    }
                    {
                        selectedFolder &&
                        <EditFolderButton folder={selectedFolder} />
                    }
                    <ToggleSearchAlbumButton />
                    <Box flexGrow={1} />
                    <Logo />
                </TopBar>
                <div style={{
                    marginTop: topbarHeight,
                    position: "relative",
                    minHeight: "100vh",
                    background: theme.bee.contentBackground,
                }}>
                    <TiledBackground offset={topbarHeight} />
                    <QuestionList data={selectedFolder?.items ?? []} />
                </div>
            </>

    )
}